import { create } from 'zustand';
import type { DropTarget } from '@/services/office/dropHitTest';

// Visual state for an in-progress mail drag over the pane.
//
// - `target` is the drop target currently under the cursor: a specific folder,
//   a project root, or null (over blank space / outside any project). It drives
//   the per-row highlight — the hovered folder lights up, or the project root
//   does — and is null when the drop would go nowhere (so nothing is
//   highlighted, matching "don't pretend a drop is possible when it isn't").
// - `dragging` is true from the first dragover until the drop / leave / timeout.
//   Only used to show the detail-page "drop into this folder" overlay, which is
//   the one place a whole-view fallback target still exists.
//
// Both drag sources feed this store: the HTML5 handlers (Classic desktop / Mac)
// on FolderRow / ContainerSection / DropZone, and the Office DragAndDropEvent
// hit-test (Outlook Web / new Outlook).
interface MailDropState {
  dragging: boolean;
  target: DropTarget | null;
  /** Mark a drag in progress over `target` (null = over blank / no valid target). */
  setDrag: (target: DropTarget | null) => void;
  /** Drag ended (dropped, left the pane, or timed out). */
  endDrag: () => void;
}

export const useMailDropStore = create<MailDropState>((set) => ({
  dragging: false,
  target: null,
  setDrag: (target) => set({ dragging: true, target }),
  endDrag: () => set({ dragging: false, target: null }),
}));
